<template>
  <div>
    <div class="theme-title">{{ theme }}</div>
    <ul class="wt-list flex-b-c-w">
      <li v-for="wt in list" :key="wt.id" class="wt-item">
        <div class="wt-item-box">
          <img :src="wt.thumb_url" />
          <div class="wt-item-handle flex-d-a-c">
            <el-button size="mini" type="danger" @click="()=>{$emit('handleTool',wt.id)}">{{ $t('cbt4') }}</el-button>
          </div>
          <span class="ellipsis-1" style="line-height: 24px; padding: 0px 4px;">{{ wt.name }}</span>
        </div>
      </li>
      <i v-for="index in 12" :key="'file-i-'+index" class="wt-item" style="height: 0px; margin: 0px 8px;"></i>
    </ul>
  </div>
</template>

<script>
export default {
  name: "WebToolList",
  props: {
    theme: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
.theme-title {
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  border-top: 1px solid #ebeef5;
  border-bottom: 2px solid #ebeef5;
  padding: 0px 16px;
}
.wt-list {
  padding: 8px;
}
.wt-item {
  width: 25%;
  max-width: 240px;
  background-color: #eefbff;
  border-radius: 4px;
  margin: 0px 8px 8px 8px;
  // margin-top: 8px;
  overflow: hidden;
  // border: 1px solid #ebeef5;
  // padding-top: calc(11.2%);
  .wt-item-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 60%;
    position: relative;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 24px);
    // pointer-events: none;
    user-select: none;
  }
  .wt-item-box:hover .wt-item-handle {
    visibility: visible;
  }
  .wt-item-handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 24px);
    visibility: hidden;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
}
</style>